// Ortak liste/tablo bileşenleri (src/components/data) için metinler.
const dataTable = {
  search: {
    minChars: 'En az 3 karakter',
    clear: 'Aramayı temizle',
  },
  statusLabel: 'Durum filtresi',
  filters: 'Filtreler',
  filtersOpen: 'Filtreler ({{count}} açık)',
  clearAll: 'Tümünü Temizle',
  removeFilter: '{{label}} filtresini kaldır',
  pendingFilter: 'Bu filtre en az 3 karakterle uygulanır',
  columns: {
    button: 'Sütunlar',
    buttonLabel: 'Sütunlar ({{count}}/{{total}} görünür)',
    title: 'Sütun Görünürlüğü',
    visible: '{{count}} / {{total}} görünür',
    showAll: 'Tümünü göster',
    reset: 'Varsayılana dön',
    resetHint: 'Varsayılan sütunlar ve genişlikler',
    lastColumn: 'En az bir sütun görünür kalmalı',
  },
  filter: {
    title: '{{label}} filtresi',
    titleOn: '{{label}} filtresi (açık)',
    placeholder: 'Ara…',
    clear: 'Temizle',
    minChars: 'En az 3 karakter girin',
    all: 'Tümü',
  },
  table: {
    resizeLabel: '{{label}} sütununun genişliği',
    resizeHint: 'Genişliği değiştirmek için sürükleyin, sıfırlamak için çift tıklayın',
    scrollLeft: 'Tabloyu sola kaydır',
    scrollRight: 'Tabloyu sağa kaydır',
    noColumns: 'Görünür sütun yok',
    showDefaultColumns: 'Varsayılan sütunları göster',
    clearFilters: 'Filtreleri Temizle',
    loading: 'Yükleniyor',
  },
  pagination: {
    noResults: 'Sonuç yok',
    loading: 'Yükleniyor…',
    pages: 'Sayfalar',
    first: 'İlk sayfa',
    previous: 'Önceki sayfa',
    next: 'Sonraki sayfa',
    last: 'Son sayfa',
    page: 'Sayfa {{page}}',
  },
  panel: {
    previous: 'Önceki kayıt',
    next: 'Sonraki kayıt',
    close: 'Kapat (Esc)',
    actions: 'İşlemler',
    details: 'Bilgiler',
    copy: 'Kopyala',
    copyLabel: '{{label}} kopyala',
    copied: '{{label}} kopyalandı',
    copyFailed: 'Panoya kopyalanamadı',
  },
  filterSheet: {
    subtitle: 'Listeyi sütunlara göre daraltın',
    show: '{{count}} sonucu göster',
  },
  form: {
    noOptions: 'Sonuç yok',
    back: 'Geri',
    nextSection: 'İleri',
    stepOf: '{{current}} / {{total}}',
    sections: 'Form bölümleri',
    outOfList: '{{value}} (liste dışı)',
    unsaved: 'Kaydedilmemiş değişiklikler var.',
    keepEditing: 'Düzenlemeye dön',
    discard: 'Kaydetmeden kapat',
    cancel: 'İptal',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    choose: 'Seçiniz',
    required: 'Bu alan zorunludur',
    fixErrors: 'Lütfen işaretli alanları düzeltin.',
    confirmDelete: 'Silinsin mi?',
    delete: 'Sil',
    edit: 'Düzenle',
  },
};

export default dataTable;
